import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams ,LoadingController} from 'ionic-angular';
import { CommonProvider } from '../../providers/common/common';
import { PropertyDocumentListPage } from '../property-document-list/property-document-list';
import { PropertyDocumentPickupPage } from '../property-document-pickup/property-document-pickup';
import {GenericFormValidationProvider} from "../../providers/common/form-validation"
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

/**
 * Generated class for the YourPropertyPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-your-property',
  templateUrl: 'your-property.html',
})
export class YourPropertyPage {

  propertyType:any=[];
  purposeType:any=[];
  propertyObj:any={};
  model:any={};
  city:any="";
  State:any="";
  purposeTypeObj:any={};
  errorDisplay:any={};
  errorSingleDisplay:any={};
  constructor(private fb: FormBuilder,private fv : GenericFormValidationProvider,private cp: CommonProvider, public loadingCtrl: LoadingController,
    public navCtrl: NavController, public navParams: NavParams) {
    this.model.lead={};
    this.model.lead.properties=[]
    this.model.applicants=[];
  }

  ionViewDidLoad() {
    this.model.lead={};
    this.getAddressType("LAP");
    this.getPurpose("LAP");
    this.veiwLead(JSON.parse(this.navParams.data.data).Payload.lead.leadid)
    
  }
veiwLead(leadid){
    let request:any = {};
    request.leadId=leadid

      let loading = this.loadingCtrl.create({
           content: 'Please wait...'
          });
          loading.present();
      this.cp.viewLeadById(loading,request).then((res:any)=>{
         loading.dismiss();
         try{
            this.navParams.data.data=res;
            //console.log("viewleadby id",JSON.parse(res));
             
            //console.log("JSON.parse(this.navParams.data.data).Payload.lead.properties[0].ibhfl_PropertyPin",JSON.parse(this.navParams.data.data)) 
            this.model.lead.ibhfl_PropertyTypeId=JSON.parse(this.navParams.data.data).Payload.lead.ibhfl_PropertyTypeId;
            this.model.lead.ibhfl_propertytype_name=JSON.parse(this.navParams.data.data).Payload.lead.ibhfl_propertytype_name;
            this.model.lead.ibhfl_LoanPurpose=JSON.parse(this.navParams.data.data).Payload.lead.ibhfl_LoanPurpose?JSON.parse(this.navParams.data.data).Payload.lead.ibhfl_LoanPurpose:"";
            this.model.lead.ibhfl_purpose_name=JSON.parse(this.navParams.data.data).Payload.lead.ibhfl_purpose_name;
            this.model.applicants=JSON.parse(this.navParams.data.data).Payload.lead.applicants;
            this.model.lead.properties=JSON.parse(this.navParams.data.data).Payload.lead.properties;

            if(JSON.parse(this.navParams.data.data).Payload.lead.properties.length>0 && JSON.parse(this.navParams.data.data).Payload.lead.properties[0].ibhfl_PropertyPin){
              this.model.lead.pincode = JSON.parse(this.navParams.data.data).Payload.lead.properties[0].ibhfl_PropertyPin;
              this.model.lead.ibhfl_addressline1 = JSON.parse(this.navParams.data.data).Payload.lead.properties[0].ibhfl_addressline1;
              this.pincodeUpdate();
            }
            
            
         }catch(e){
          //////console.log(e)
         }
       })
  }  
changePurposeType(purpose){
//console.log("purpose",purpose)
} 
changeAddressType(purpose){
//console.log("purpose",purpose)
}  
getAddressType(loanType){
    let loading = this.loadingCtrl.create({
           content: 'Please wait...'
          });
          loading.present();
    let request:any={}
    request.propertyType=  loanType  
    this.cp.propertyType(loading,request).then((res:any)=>{
      loading.dismiss();
         
        this.propertyType = JSON.parse(res).Payload.propertytypes
         this.propertyType.sort((a, b) => {
            return parseInt(a.ibhfl_code) - parseInt(b.ibhfl_code);
        });
         this.propertyObj=this.propertyType.filter((res:any)=>{
          return res.ibhfl_code==this.navParams.data.selectedtype
         })
          
         this.propertyObj=this.propertyType[0]
        

    })
  }
  getPurpose(loanType){
    let loading = this.loadingCtrl.create({
           content: 'Please wait...'
          });
          loading.present();
    let request:any={}
    request.propertyType=  loanType  
    this.cp.getPurpose(loading,request).then((res:any)=>{
      loading.dismiss();
         
        this.purposeType = JSON.parse(res).Payload.purposes
         this.purposeType.sort((a, b) => {
            return parseInt(b.ibhfl_code) - parseInt(a.ibhfl_code);
        });
         
         // this.model.lead.ibhfl_LoanPurpose=this.purposeType[0].ibhfl_code;
         // this.model.lead.ibhfl_purpose_name=this.purposeType[0].ibhfl_name; 
          
         this.purposeTypeObj=this.purposeType[0]
        

    })
  }
  pincodeUpdate(){
    if(this.model.lead.pincode ){
      ////console.log("pincode updated",this.model.lead.pincode);
    let loading = this.loadingCtrl.create({
           content: 'Please wait...'
          });
          loading.present();
    let request:any={}
    request.pincodeID = this.model.lead.pincode     
    this.cp.getCityByPincode(loading,request).then((res:any)=>{
      loading.dismiss();

       //console.log(JSON.parse(res),"res data");
       if(JSON.parse(res).Payload.ibhfl_pincodes.length>0){

       this.model.lead.ibhfl_PropertyCityId = JSON.parse(res).Payload.ibhfl_pincodes?JSON.parse(res).Payload.ibhfl_pincodes[0].ibhfl_city.ibhfl_citycode:"";
       
       this.model.lead.city_name = JSON.parse(res).Payload.ibhfl_pincodes?JSON.parse(res).Payload.ibhfl_pincodes[0].ibhfl_city.ibhfl_name:"";
        
       this.model.lead.ibhfl_PropertyStateId=JSON.parse(res).Payload.ibhfl_pincodes?JSON.parse(res).Payload.ibhfl_pincodes[0].ibhfl_state.ibhfl_statecode:"";
       this.model.lead.state_name = JSON.parse(res).Payload.ibhfl_pincodes?JSON.parse(res).Payload.ibhfl_pincodes[0].ibhfl_state.ibhfl_name:"";
       
       }
    })
    }
    
  }
  //  checkValidation(keyname?:any){
  //  if(Object.keys(this.errorDisplay).length>0){
  //   this.errorDisplay = this.fv.checkValidationFormAllControls(document.forms['your-property'],true,[]);
   
  //  }
   
  // }
  checkValidation(keyname?:any){
   if(Object.keys(this.errorDisplay).length>0){
    this.errorSingleDisplay = this.fv.checkValidationFormAllControls(document.forms['your-property'],true,[]);
    if(Object.keys(this.errorSingleDisplay).length>0){
     var index = Object.keys(this.errorSingleDisplay).findIndex((res:any)=>{
        return res==keyname
      })
        //console.log(index);

      if(index==-1){
        delete this.errorDisplay[keyname];
        if(this.errorDisplay.length>0 && this.errorDisplay.length<=1)
        {
          this.errorDisplay.valid=false
        }
        //console.log(this.errorDisplay);
      }
    }
    
   }
   
  }
  updateLead(){
    this.errorDisplay = this.fv.checkValidationFormAllControls(document.forms["your-property"],true,[]);
    if(this.errorDisplay.valid){
     return false;
   }else{


    let jsonRequest:any={};;
    jsonRequest.lead={};
    jsonRequest.lead.properties=[];
    jsonRequest.applicants=[];
    let applicantsRequest:any={};
    applicantsRequest.ibhfl_ispropertyidentified="true"
    jsonRequest.lead.leadid = JSON.parse(this.navParams.data.data).Payload.lead.leadid;
    jsonRequest.lead.ibhfl_LoanPurpose = this.model.lead.ibhfl_LoanPurpose;
    jsonRequest.lead.ibhfl_propertyidentified =true;
    jsonRequest.lead.ibhfl_PropertyTypeId = this.model.lead.ibhfl_PropertyTypeId
     
    jsonRequest.applicants.push(applicantsRequest)
    jsonRequest.lead.ibhfl_stageid="2.1"

    let propertiesObj:any={};
    if(this.model.lead.properties.length>0){
      this.model.lead.properties.forEach((res:any)=>{
        propertiesObj.leadid = JSON.parse(this.navParams.data.data).Payload.lead.leadid
        propertiesObj.ibhfl_purchasingfrom = JSON.parse(this.navParams.data.data).Payload.lead.applicants[0].ibhfl_applicantrole.toString();
        propertiesObj.propertyid = JSON.parse(this.navParams.data.data).Payload.lead.properties[0].propertyid
        propertiesObj.ibhfl_propertytype = this.model.lead.ibhfl_PropertyTypeId
        propertiesObj.ibhfl_isplot = false
        propertiesObj.ibhfl_PropertyCityId = this.model.lead.ibhfl_PropertyCityId
        propertiesObj.ibhfl_city_name = this.model.lead.city_name
        propertiesObj.ibhfl_addressline1 = this.model.lead.ibhfl_addressline1
        propertiesObj.ibhfl_PropertyPin = this.model.lead.pincode
        propertiesObj.ibhfl_PropertyStateId = this.model.lead.ibhfl_PropertyStateId
        propertiesObj.ibhfl_state_name = this.model.lead.state_name
      })
      jsonRequest.lead.properties.push(propertiesObj)
    }
    //console.log("jsonRequest",JSON.stringify(jsonRequest));

          let loading = this.loadingCtrl.create({
           content: 'Please wait...'
          });
          loading.present();
          this.cp.updateLead(loading,jsonRequest).then((res:any)=>{
          loading.dismiss();
           
           try{
            //console.log(JSON.parse(res));
                // this.navCtrl.push(,{"leadid":JSON.parse(this.navParams.data.data).Payload.lead.leadid})
            this.navParams.data.leadid= JSON.parse(this.navParams.data.data).Payload.lead.leadid   
            this.navCtrl.push(PropertyDocumentPickupPage,this.navParams); 
            // this.navCtrl.push(PropertyDocumentListPage,this.navParams)
            
            
           }catch(e){
            //console.log("error getting",e);
           }
         })
    }
  }

   
}



// WEBPACK FOOTER //
// ./src/pages/your-property/your-property.ts